<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>

      <v-card-text>
        <!-- 検索条件エリア -->
        <v-row dense>
          <v-col cols="4">
            <TextFieldInput :label="$t('ELE0003')" v-model="searchCondition.companyCd" />
          </v-col>
          <v-col cols="4">
            <TextFieldInput :label="$t('ELE0004')" v-model="searchCondition.companyName" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <span class="d-flex flex-row space-between mr-4">
              <Checkbox class="mr-4" :label="$t('ELE0022')" v-model="searchCondition.validOnly" />
              <Checkbox class="mr-4" :label="$t('ELE0492')" v-model="searchCondition.needSource" />
              <v-spacer />
              <BtnSearch class="mt-2" @click="onClickSearch" />
            </span>
          </v-col>
        </v-row>

        <!-- 検索結果エリア -->
        <v-row dense>
          <v-col>
            <v-card outlined>
              <v-card-title class="pt-1 pb-0">
                {{ $t('ELE0023') }}
                <v-spacer />
                <BtnAdd @click="addItem" />
              </v-card-title>
              <v-data-table :headers="headersComputed" :items="items" dense>
                <template v-slot:[`item.action`]="{ item }">
                  <IconInquiry @click="inquiryItem(item)" left />
                  <IconEdit @click="editItem(item)" right />
                </template>
                <template v-slot:[`item.isSrcInsp`]="{ item }">
                  {{ $t('isSrcInsp.' + item.isSrcInsp) }}
                </template>
                <template v-slot:[`item.isValid`]="{ item }">
                  {{ $t('isValid.' + item.isValid) }}
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-container>

    <CompanyDialog
      v-if="item !== null"
      :dialog.sync="dialog"
      :mode="mode"
      :companyCd.sync="item.companyCd"
      :compCd.sync="item.compCd"
      :location.sync="item.location"
      :locationRequired="locationRequired"
      :capacityRequired="capacityRequired"
      :companyName.sync="item.companyName"
      :companyCatCd.sync="item.companyCatCd"
      :inspCat.sync="item.inspCat"
      :isSrcInsp.sync="item.isSrcInsp"
      :isValid.sync="item.isValid"
      :supplierCds.sync="selectedItem.acceptCompanies"
      :versionNo.sync="item.versionNo"
      :capaInsp.sync="item.capaInsp"
      :gnsCompany="item.m_gnsCompany"
      :propsShiftGroupCd="item.shiftGroupCd"
      @change="onClickSearch"
    />
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import { ModalMode, SystemParameterKey } from '@/enum'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import Btn from '@/components/atoms/base/button/Btn'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnAdd from '@/components/atoms/button/BtnAdd'
import IconEdit from '@/components/atoms/icon/IconEdit'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import CompanyDialog from '@/components/organisms/master/dialog/CompanyDialog'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'CompanyForm',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    TextFieldInput,
    Btn,
    Checkbox,
    CompanyDialog,
    BtnSearch,
    BtnAdd,
    IconEdit,
    IconInquiry,
  },

  data() {
    return {
      dialog: false,
      mode: '', // モーダルの処理モード
      searchCondition: {
        companyCd: '',
        companyName: '',
        validOnly: true,
        needSource: false,
      },
      headers: [
        { text: '', divider: true, width: '90', sortable: false, value: 'action' },
        { text: this.$t('ELE0003'), divider: true, value: 'compCd' },
        { text: this.$t('ELE0380'), divider: true, value: 'location' },
        { text: this.$t('ELE0004'), divider: true, value: 'companyName' },
        { text: this.$t('ELE0494'), divider: true, value: 'isSrcInsp' },
        { text: this.$t('ELE0014'), divider: true, value: 'isValid' },
        { text: this.$t('ELE0029'), divider: true, value: 'itemUpdatedBy' },
        { text: this.$t('ELE0039'), divider: true, value: 'updaterUserName' },
        { text: this.$t('ELE0030'), divider: false, value: 'editItemUpdatedAt' },
      ],
      items: [],
      item: null,
      selectedItem: {
        acceptCompanies: [],
      },
      locationRequired: false,
      capacityRequired: false,
      emptyItem: {
        companyCd: '',
        compCd: '',
        location: '',
        companyName: '',
        companyCatCd: '',
        inspCat: '',
        isSrcInsp: false,
        isValid: true,
        versionNo: 0,
        capaInsp: '',
        m_gnsCompany: {
          companyName1: '',
          companyName2: '',
        },
      },
    }
  },

  computed: {
    headersComputed: {
      get() {
        return this.headers?.filter((item) => {
          if (item.value == 'location') {
            return this.locationRequired
          }
          return item
        })
      },
    },
  },

  methods: {
    async addItem() {
      // 追加モードでモーダルopen
      this.mode = ModalMode.ADD
      this.item = cloneDeep(this.emptyItem)
      this.dialog = true
    },
    async editItem(item) {
      // 編集モードでモーダルopen
      this.mode = ModalMode.EDIT
      this.item = cloneDeep(item)
      this.selectedItem.acceptCompanies = await this.getAcceptCompany(item.companyCd)
      this.dialog = true
    },
    async inquiryItem(item) {
      // 参照モードでモーダルopen
      this.mode = ModalMode.INQUIRY
      this.item = cloneDeep(item)
      this.selectedItem.acceptCompanies = await this.getAcceptCompany(item.companyCd)
      this.dialog = true
    },
    async onClickSearch() {
      // 検索
      this.startLoading()

      try {
        const params = {
          companyCd: this.searchCondition.companyCd,
          companyName: this.searchCondition.companyName,
          validOnly: this.searchCondition.validOnly,
          needSource: this.searchCondition.needSource,
        }
        this.items = []

        const elements = await API.get('/master/companies', params)
        this.items = elements.map((element) => {
          element['editItemUpdatedAt'] = this.toLocalTime(element['itemUpdatedAt'])
          element['updaterUserName'] = element['m_user']['userName']
          // GNScompanyを使いやすいように整理
          if (!element.m_gnsCompany) {
            element['m_gnsCompany'] = { companyName1: '', companyName2: '' }
          }
          return element
        })
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
      } finally {
        this.stopLoading()
      }
    },
    async getAcceptCompany(companyCd) {
      this.startLoading()
      try {
        const params = {
          companyCd: companyCd,
        }
        const elements = await API.get('/master/acceptCompanies', params)
        return elements.map((element) => {
          return element['supplierCd']
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0005') })))
      } finally {
        this.stopLoading()
      }
    },
    async initSystemParameters() {
      try {
        this.startLoading()
        const param = await API.get(`/master/systemParameters?key=COMPANY`)
        param?.forEach((element) => {
          if (element.key == SystemParameterKey.COMPANY_LOC_REQ) {
            this.locationRequired = element.value == 'TRUE'
          }
          if (element.key == SystemParameterKey.COMPANY_CAPA_REQ) {
            this.capacityRequired = element.value == 'TRUE'
          }
        })
      } catch (error) {
        if (error.response.status != 404) {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0348') })))
        }
      } finally {
        this.stopLoading()
      }
    },
  },
  async mounted() {
    await this.initSystemParameters()
    this.onClickSearch()
  },
}
</script>
